import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Role {
  name: string;
  api_token: string;
}

export interface RoleInfo {
  errors: unknown;
  listRole: Role;
  isAuthenticated: boolean;
}

@Module
export default class RoleModule extends VuexModule implements RoleInfo {
  errors = {};
  listRole = {} as Role;
  listPermission = {};
  roleDetail = {};
  listMemberByRole = {};
  isAuthenticated = !!JwtService.getToken();

  get getListRole() {
    return this.listRole;
  }

  get getRoleDetail() {
    return this.roleDetail;
  }

  get getListPermission() {
    return this.listPermission;
  }

  get getListMemberByRole() {
    return this.listMemberByRole;
  }

  @Mutation
  [Mutations.ROLE_LIST_DATA](listRole) {
    this.listRole = listRole;
  }

  @Mutation
  [Mutations.PERMISSION_LIST_DATA](listPermission) {
    this.listPermission = listPermission;
  }

  @Mutation
  [Mutations.ROLE_DETAIL_DATA](roleDetail) {
    this.roleDetail = roleDetail;
  }

  @Mutation
  [Mutations.MEMBER_LIST_BY_ROLE_DATA](listMemberByRole) {
    this.listMemberByRole = listMemberByRole;
  }

  @Action
  [Actions.ROLE_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/role", payload)
        .then((data) => {
          this.context.commit(Mutations.ROLE_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }

  @Action
  [Actions.ROLE_DETAIL](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post(`/role/${payload.id}/detail`)
        .then((data) => {
          this.context.commit(Mutations.ROLE_DETAIL_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }

  @Action
  [Actions.PERMISSION_LIST]() {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/permissions")
        .then((data) => {
          this.context.commit(Mutations.PERMISSION_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }

  @Action
  [Actions.MEMBER_LIST_BY_ROLE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      const id = payload.id;
      delete payload.id;
      return ApiService.post(`/role/${id}/members`, payload)
        .then((data) => {
          this.context.commit(Mutations.MEMBER_LIST_BY_ROLE_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }

  @Action
  [Actions.ROLE_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post(`role/${payload.id}/delete`, payload)
        .then((res) => {
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }

  @Action
  [Actions.ROLE_UPSERT](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      const idPath = payload.id ? `/${payload.id}` : "";
      return ApiService.post(`/role/upsert${idPath}`, payload)
        .then(() => {
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }
}
